export default "__VITE_ASSET__IuJLjx3M__"